import styled from "styled-components";

export const PutAwayInvoiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .searchInvoiceWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }
  .searchInvoice {
    display: flex;
    gap: 10px;
    .billNumber,
    .invoiceNumber {
      flex: 1;
    }
  }
  .statusTabs {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 0;
    justify-content: space-between;
    .statusWrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      .label {
        font-size: 17px;
      }
    }
  }
  .statusTabs .ant-segmented-item {
    margin: 0;
  }
  .ant-segmented-item-selected {
    div.racked {
      background-color: white !important;
    }
  }
`;
